<style scoped>
	
	
	.line-box {
		display: flex; flex-direction: row;  align-items: center;
		margin-left: 30px;
	}
	.line-name {
		width: 130px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
		margin-left: 30px;
	}
	.line-tag {
		width: 700px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
		margin-bottom: 30px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 60px;
	    height: 60px;
	    line-height: 60px;
	    text-align: center;
	  }
	  .avatar {
	    width: 60px;
	    height: 60px;
	    display: block;
	  }
</style>

<template>
	<div class="content">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="getData" style="margin-right: 20px;"></el-button>
			
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>系统设置</el-breadcrumb-item>
			  <el-breadcrumb-item>免责声明</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="background-color: white; margin: 10px; padding: 30px 0; border-radius: 10px;">
			<div style="display: flex; flex-direction: row;">
				<div class="line-name">免责声明：</div>
				<el-input type="textarea" v-model="statement" style="width:860px;" rows="20"></el-input>
			</div>
			
			<div style="width: 100%; margin-top: 20px; margin-left: 140px;">
				<el-button style="width: 860px;" type="primary" @click="submit">提交保存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				statement:''
			}
		},
		created(){
			this.getData();
		},
		methods: {
			getData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/System/getStatement", {}).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.statement = res.data;
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submit(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '保存中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/System/setStatement", {statement:_this.statement}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
					
				}).catch(err=>{
					loading.close();
				});
			},
		},
	}
</script>
